'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _keyMirror2.default)({
  SUCCEED_GET_MAB_COPY: null,
  FAILED_GET_MAB_COPY: null,
  REQUEST_MAB_COPY: null,
  FAILED_GET_MAB_COPY_WITHIN_TIMEOUT: null
});
module.exports = exports['default'];